const productFormPrice = document.querySelector('.product-block.product-block--price');
const fixedAddToCartPrice = document.querySelector('.simple-sticky-add-to-cart .price-wrapper');
const fixedAddToCartButton = document.querySelector('.simple-sticky-add-to-cart .btn');
const productFormButton = document.querySelector('.product-single__form .add-to-cart-event');

if (productFormPrice && fixedAddToCartPrice) {
  fixedAddToCartPrice.innerHTML = productFormPrice.innerHTML;
}

fixedAddToCartButton.addEventListener('click', () => {
  // In the future, we will add logic for the “out of stock” button state
  productFormButton.click();
})

let eventTimeout;

function bodyPaddingHandler() {
  // We use this approach to reduce the number of calls to just one when the event is over
  clearTimeout(eventTimeout);

  eventTimeout = setTimeout(() => {
    if (window.innerWidth <= 767) {
      const fixedAddToCart = document.querySelector('.simple-sticky-add-to-cart');
      if (fixedAddToCart) {
        document.body.style.paddingBottom = `${fixedAddToCart.offsetHeight}px`;
      }
    } else {
      document.body.style.paddingBottom = '0px';
    }
  }, 250);
}

document.addEventListener('DOMContentLoaded', bodyPaddingHandler);
window.addEventListener('resize', bodyPaddingHandler);
window.addEventListener('orientationchange', bodyPaddingHandler);

document.body.classList.add('is--bundle-sticky');